"use strict";

// fixed header content space
function fixedHeaderSpace() {
    const navbar = document.querySelector('.adminuiux-header .navbar');
    const sidebar = document.querySelector('.adminuiux-sidebar');
    const content = document.querySelector('.adminuiux-content');
    
    if (navbar && navbar.classList.contains('fixed-top')) {
        const navbarHeight = navbar.offsetHeight;
        
        if (sidebar) {
            sidebar.style.paddingTop = navbarHeight + 'px';
        }
        
        if (content) {
            content.style.paddingTop = navbarHeight + 'px';
        }
    }
}

window.fixedHeaderSpace = fixedHeaderSpace;

// feather icons 
function featherjs() {
    if (typeof feather !== 'undefined') {
        feather.replace();
    }
}
window.featherjs = featherjs;

// editor FroalaEditor
function froalaeditor() {
    const editors = document.querySelectorAll('.FroalaEditor');
    if (editors.length > 0 && typeof FroalaEditor !== 'undefined') {
        const editor = new FroalaEditor('.FroalaEditor');
    }
}
window.froalaeditor = froalaeditor;

function activeHeader() {
    const header = document.querySelector('.adminuiux-header');
    if (header) { // Добавлена проверка на существование элемента
        if (window.scrollY > 30) {
            header.classList.add('active');
        } else {
            header.classList.remove('active');
        }
    }
}
window.activeHeader = activeHeader;

function scrolldirection() {
    var lastScrollTop = document.documentElement.scrollTop;
    var body = document.body; // Переменная body не была определена

    window.addEventListener("scroll", function () {
        var st = document.documentElement.scrollTop;
        if (st > lastScrollTop) {
            body.classList.add('scrolldown'); // Исправлено на classList
            body.classList.remove('scrollup'); // Исправлено на classList
        } else if (st <= lastScrollTop) {
            body.classList.add('scrollup'); // Исправлено на classList
            body.classList.remove('scrolldown'); // Исправлено на classList
        }
        lastScrollTop = st <= 0 ? 0 : st; // Защита от отрицательных значений
    }, false);
}
window.scrolldirection = scrolldirection;